import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { AppDispatch } from '../store'
import { fetchApplicationList } from '../store/applicationsSlice'
import { RootState } from '../store/rootReducer'
import Pagination from '../components/Pagination'

const Applications = (): React.ReactElement | null => {
  const { t } = useTranslation('applications')
  const dispatch = useDispatch<AppDispatch>()
  const { applications, loading, error, totalPages, currentLimit, currentPage, totalCount } = useSelector(
    (state: RootState) => state.applications
  )
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)

  useEffect(() => {
    dispatch(
      fetchApplicationList({
        page,
        limit,
      })
    )
  }, [dispatch, page, limit])

  if (loading === 'pending') {
    // TODO: Loader...
    return null
  }

  if (error) {
    // TODO: Upp kom óvænt villa...
    return null
  }

  return (
    <Card>
      <Card.Body>
        <h4>{t('umsoknir')}</h4>
        {applications == null || applications.length === 0 ? (
          <div className="pb-3 pt-3">
            <i>{t('engarUmsoknir')}.</i>
          </div>
        ) : (
          <div className="mt-3">
            <table className="table">
              <thead>
                <tr className="bg-gray-200 small">
                  <th>{t('nafn')}</th>
                  <th className="d-none d-md-block">{t('kennitala')}</th>
                  <th>{t('timabil')}</th>
                  <th>{t('vinnustadur')}</th>
                  <th>{t('stada')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {applications?.map((application) => (
                  <tr key={application.id}>
                    <td>{application.name}</td>
                    <td className="d-none d-md-block">{application.ssn}</td>
                    <td>
                      {application.period.name}
                      <div style={{ display: 'block', fontSize: '13px' }}>
                        {application.period_parts && application.period_parts.length > 0 ? (
                          application.period_parts.map((part) => (
                            <div key={part.id} style={{ display: 'block' }}>
                              <i>
                                {dayjs(part.period_part.date_from).format('DD.MM.YYYY')} -{' '}
                                {dayjs(part.period_part.date_to).format('DD.MM.YYYY')}
                              </i>
                            </div>
                          ))
                        ) : (
                          <i>
                            {dayjs(application.period.date_from).format('DD.MM.YYYY')} -{' '}
                            {dayjs(application.period.date_to).format('DD.MM.YYYY')}
                          </i>
                        )}
                      </div>
                    </td>
                    <td>
                      {application.workplaces.map((workplace) => (
                        <div key={workplace.id}>
                          <div className="d-inline-block">{workplace.name}</div>
                        </div>
                      ))}
                    </td>
                    <td>
                      {application.status === 'NEW' && t('nyskrad')}
                      {application.status === 'SEMI_ACCEPTED' && t('afgreiddAdHluta')}
                      {application.status === 'ACCEPTED' && t('afgreidd')}
                      {application.status === 'REJECTED' && t('hafnad')}
                      {application.status === 'CANCELLED' && t('afskrad')}
                    </td>
                    <td>
                      <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-view`}>{t('skoda')}</Tooltip>}>
                        <Link
                          className="btn btn-secondary float-right"
                          style={{ color: '#fff' }}
                          to={`/umsokn/${application.id}`}
                        >
                          <div className="d-inline-block">
                            <FontAwesomeIcon icon={faSearch} />
                          </div>
                        </Link>
                      </OverlayTrigger>

                      {application.status === 'NEW' && (
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id={`tooltip-change`}>{t('breyta')}</Tooltip>}
                        >
                          <Link
                            className="btn btn-primary float-right"
                            style={{ color: '#fff' }}
                            to={`/breytaumsokn/${application.id}`}
                          >
                            <div className="d-inline-block">
                              <FontAwesomeIcon icon={faPencilAlt} />
                            </div>
                          </Link>
                        </OverlayTrigger>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalPages > 1 && (
              <Pagination
                currentLimit={currentLimit}
                currentPage={currentPage}
                currentLength={applications.length}
                totalCount={totalCount}
                totalPages={totalPages}
                onPageChange={setPage}
                onLimitChange={setLimit}
              />
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default Applications
